import { useState } from "react";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";

const months = [
  "Jan.",
  "Feb.",
  "Mar.",
  "Apr.",
  "May",
  "Jun.",
  "Jul.",
  "Aug.",
  "Sep.",
  "Oct.",
  "Nov.",
  "Dec.",
];

const days = ["Sun.", "Mon.", "Tue.", "Wed.", "Thu.", "Fri.", "Sat."];

export default function EventCard({ event, counter }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // console.log(counter);
  //console.log(event);
  const eventDate = new Date(event.year, event.month, event.day);
  const startMinutes =
    event.startMinutes < 10
      ? `0${event.startMinutes}`
      : `${event.startMinutes}`;
  const bgColorClasses = ["bg-info", "bg-success", "bg-primary", "bg-warning"];
  return (
    <div className="event-card">
      <div
        className={`container-flex rounded-4 m-2 p-3 ${
          bgColorClasses[(counter + 3) % 4]
        }`}
      >
        <h4 className="text-white d-flex justify-content-between">
          <div>{`${days[eventDate.getDay()]}, ${months[event.month]} ${
            event.day
          }`}</div>
          {event.name.includes("Peaman") && (
            <div title="Swim/Run Event" data-toggle="tooltip">
              🏊 🏃
            </div>
          )}
          {event.name.includes("Group Run") | event.name.includes("5K") ? (
            <div title="Running Event" data-toggle="tooltip">
              🏃
            </div>
          ) : (
            ""
          )}
          <div>
            {event.startHour < 13
              ? `${event.startHour}:${startMinutes} a.m.`
              : `${event.startHour - 12}:${startMinutes} p.m.`}
          </div>
        </h4>
        <div className="container bg-white mx-auto mb-3 p-3 rounded-4">
          <h3 className="text-center">{event.name}</h3>
          <div className="text-center">
            <Button variant="outline-danger" onClick={handleShow}>
              Details
            </Button>
          </div>
          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>{event.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>{`Date: ${months[event.month]}. ${event.day}, ${
                event.year
              }`}</p>
              <p>
                Time:{" "}
                {event.startHour < 13
                  ? `${event.startHour}:${startMinutes} a.m.`
                  : `${event.startHour - 12}:${startMinutes} p.m.`}
              </p>
              <p>Location: {event.location}</p>
              <div>
                Description:{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: event.description }}
                ></span>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
}
